<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-24 14:20:31
 * @Description: file content
 -->
<template>
  <div class="mymodal" v-show="value">
    <div class="msgbox" :class="{ big: message.prizeInfo && message.prizeInfo.prizeType != 1, thanks: !message.prizeId}">
      <div class="title"></div>
      <template v-if="!message.prizeId">
        <div class="content">
          <!-- <div class="tip1">
            · 很遗憾 ·
          </div> -->
          <div class="tip2" v-html="message.thanksTxt"></div>
        </div> 
        <div class="btns thanks">
          <div class="my_btn" @click="goShare">我要推荐</div>
        </div>
      </template>
      <template v-else-if="message.prizeInfo">
        <div class="content">
          <!-- <div class="tip1">
          </div> -->
          <div class="tip2" v-if="message.prizeInfo.prizeType === 1">恭喜您获得{{ message.prizeInfo.prizeName}}，<br />为验证身份信息有效，<br />请正确输入验证码。<br />传播活动还可获得更多额外金喜！</div>
          <div class="tip2" v-else>恭喜您获得{{message.prizeInfo.prizeName}}一个，<br />请正确填写信息，<br />稍后将兑换码发送到您的手机上，<br />请根据活动规则领取奖品。</div>
          <div class="input_txt" v-if="message.prizeInfo.prizeType != 1">
            <input @blur="blurInput" v-model="name" type="text" placeholder="姓名：" />
          </div>
          <div class="input_txt">
            <input @blur="blurInput" v-model="mobile" type="tel" placeholder="联系方式：" />
          </div>
          <div class="input_txt">
            <div class="left">
              <input @blur="blurInput" v-model="vcode" type="number" placeholder="验证码：" oninput="if(value.length>6)value=value.slice(0,6)" />
            </div>
            <div class="right">
              <div @click="getVcode" v-if="!showVcode">{{getVcodes}}</div>
              <div v-else>{{counts}}s</div>
            </div>
          </div>
          <div class="input_txt" v-if="message.prizeInfo.prizeType != 1">
            <Multiselect
              v-model="userAdress"
              :options="addrList"
              placeholder="兑换地址："
              :searchable="false"
              @input="selectAddr"
              :allow-empty="false"
              :show-labels="false"
              track-by="name"
              label="name"
            >
              <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
            </Multiselect>
          </div>
        </div>
        <!-- <div class="content replace" v-else>
            <template v-if="!isreplaceList">
              <div class="tip1">
                <img
                  :src="imgHost + 'draw_form_txt1.png?v=1'"
                />
              </div>
              <div class="tip2">获得价值{{message.prizeInfo.originalPrice}}元{{message.prizeInfo.prizeName}}抢购机会！<br />确认即可{{message.prizeInfo.prizePrice}}元领走！<br />如不喜欢可有一次等值兑换机会，请您谨慎选择～</div>
            </template>
            <template v-else>
              <div class="tip1">
                <img
                  :src="imgHost + 'draw_form_txt3.png?v=1'"
                />
              </div>
              <div class="replaceList">
                <div class="replaceGoods" v-for="(item, index) in replaceList" :key="index">
                  <span>
                    <span style="color: #FFC300;">{{item.prizePrice}}元</span>
                    抢{{item.prizeName}}
                  </span>
                  <span
                    @click="goSelect(item.id)"
                  >兑换</span>
                </div>
              </div>
            </template>
        </div> -->
        <div class="btns">
          <div class="my_btn" @click="submit">提交领取</div>
        </div>
        <!-- <div class="btns thanks" v-else-if="!isreplaceList">
          <div class="my_btn" @click="isReplace = true">确定</div>
          <div class="my_btn" @click="goReplace">想换</div>
        </div> -->
      </template>
      <img
        class="close"
        @click="clickClose"
        src="https://yqweb.oss-cn-shanghai.aliyuncs.com/activies/floppy-bird/close_news.png"
        alt
      />
    </div>
  </div>
</template>

<script>
import { MessageBox, Toast, Indicator } from "mint-ui";
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  props: {},
  data() {
    return {
      value: false,
      title: "",
      message: "",
      callback: null,
      userInfo: this.$userInfo,
      vcode: "",
      name: "",
      mobile: "",
       //选则领奖地址
      userAdress: [],
      addressId: "",
      addressName: '',
      addrList: [],
      addressList: [],
      counts: "",
      timers: null,
      getVcodes: "获取验证码",
      showVcode: false,
      prizeId: 0,
      replaceList: [], //替换的商品
      isreplaceList: false, // 是否调用过替换商品的接口
      isReplace: false, //是否替换商品
    };
  },
  watch: {
    value: function(newVal) {
      if (newVal) {
        this.message.prizeId && this.getPrizeById(this.message.prizeId)
        this.showVcode = false;
        clearInterval(this.timers);
        this.timers = null;
        this.vcode = "";
        this.isreplaceList = false
        this.isReplace = false
        console.log(this.message)
      }
    }
  },
  computed: {},
  methods: {
    //想换 弹出替换的商品
    goReplace() {
      let that = this;
      // 想要替换的商品
      this.$httpdf
        .get(this.apiHost + 'prize/level', {
          prizeId: this.prizeId
        })
        .then((data) => {
          if (data.code == 0) {
            that.replaceList = data.data;
          }
          this.isreplaceList = true;
          if (data.code != 0 || data.data.length < 1) {
            MessageBox.alert("抱歉,没有同等级可换选商品!");
          }
        });
    },
    //确认选择
    goSelect(id) {
      let that = this;
      that.getPrizeById(id);
      let url = this.apiHost + `prize/level/${this.prizeId}/to/${id}`;
      that.$httpdf.post(url)
        .then((data) => {
          if (data.code == 0) {
            this.isReplace = true
          }
        });
    },
    //我要推荐
    goShare() {
      this.value = false;
      let text = {
        text1: "点击",
        text2: "右上角",
        text3: "推荐好友参与",
        text4: "让你和TA都获得佣金，",
        text5: "快去消息列表看看",
        text6: "会有什么神奇的事情发生吧！",
      };
      this.$modal.share.alert(text).then((res) => {
        if (res == "onSave") {
          this.$goPage("poster");
        }
      });
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      this.temporaryRepair();
    },
    // 获取对应奖品的地址
    async getPrizeById(prizeId) {
      const data = await this.$httpdf.get(this.apiHost + 'prize/getPrizeById', { prizeId: prizeId })
      if (data.code == 0) {
        this.prizeId = prizeId
        this.$set(this.message, 'prizeInfo', data.data.prize)
        if (data.data.address) {
          this.addrList = [];
          // debugger
          data.data.address.forEach((v, i) => {
            let obj = {};
            obj.addressId = v.addressId;
            obj.addressName = v.addressName;
            obj.name = v.addressName;
            obj.id = i;
            this.addrList.push(obj);
          });
        }
      } else {
        MessageBox.alert(data.msg);
      }
    },
    selectAddr: function (data) {
      this.userAdress = data;
      console.log(this.userAdress);
      this.addressName = data.addressName;
      this.addressId = data.addressId;
    },
    //获取验证码
    getVcode() {
      const _self = this;
      const TIME_COUNT = 60;
      if (!this.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        //获取验证码
        let url = this.apiHost + `common/smsCode`;
        let data = new FormData();
        data.append("mobile", this.mobile);
        this.$httpdf
          .post(
            url,
            data
          )
          .then((data) => {
            if (data.code == 0) {
              Toast({
                message: "验证码已发送至您的手机",
                duration: 2000,
              });
              if (!_self.timers && _self.mobile) {
                _self.counts = TIME_COUNT;
                _self.showVcode = true;
                _self.timers = setInterval(() => {
                  if (_self.counts > 0 && _self.counts <= TIME_COUNT) {
                    _self.counts--;
                  } else {
                    _self.showVcode = false;
                    clearInterval(_self.timers);
                    _self.timers = null;
                  }
                }, 1000);
              }
            } else {
              MessageBox.alert(data.msg);
            }
          });
      }
    },
    //提交手机号
    async submit() {
      let _self = this;
      if (!_self.name) {
        return MessageBox.alert("请输入姓名", "提示");
      } else if (!_self.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        if (!this.$util.isMobile(_self.mobile)) {
          return MessageBox.alert("请填写正确的手机号", "提示");
        }
      }
      if (!_self.vcode) {
        return MessageBox.alert("请输入验证码", "提示");
      }
      if (_self.message.prizeInfo.prizeType !== 1) {
        if (!_self.addressId) {
          return MessageBox.alert("请选择兑奖地址", "提示");
        }
      }
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      if (_self.message.prizeInfo.prizeType !== 1 && !_self.message.isCoupon) {
        const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/receive',
         {
           addressId: this.addressId,
           addressName: this.addressName,
           code: this.vcode,
           mobile: this.mobile,
           name: this.name,
           prizeId: this.message.prizeInfo.id
         })
        if (data.code == 0) {
          Indicator.close();
          Toast({
            message: "领取成功",
            duration: 2000,
          });
          this.value = false;
          this.callback("cancel")
        } else {
          Indicator.close();
          MessageBox.alert(data.msg);
        }
      } else if(_self.message.isCoupon) {
        const data = await this.$httpdf.get(this.apiHost + 'order/receivePrize',
         {
           addressId: this.addressId,
           addressName: this.addressName,
           code: this.vcode,
           mobile: this.mobile,
           name: this.name,
           prizeId: this.message.prizeInfo.id
         })
        if (data.code == 0) {
          Indicator.close();
          Toast({
            message: "领取成功",
            duration: 2000,
          });
          this.value = false;
          this.callback("cancel")
        } else {
          Indicator.close();
          MessageBox.alert(data.msg);
        }
      } else {
        let url
        if (this.message.user) {
          url = this.apiHost + `lucky/prize/receiveFreeRedPac?mobile=${_self.mobile}&code=${_self.vcode}&prizeId=${_self.message.prizeInfo.id}&name=${_self.name}`;
        } else {
          url = this.apiHost + `lucky/prize/receiveRedPac?mobile=${_self.mobile}&code=${_self.vcode}&prizeId=${_self.message.prizeInfo.id}&name=${_self.name}`;
        }
        const data = await this.$httpdf.get(url)
        if (data.code == 0) {
          Indicator.close();
          Toast({
            message: "领取成功",
            duration: 2000,
          });
          this.value = false;
          this.callback("cancel")
        } else {
          Indicator.close();
          MessageBox.alert(data.msg);
        }
      }
    },
    clickClose() {
      if (!this.message.isMyprize && this.message.prizeId && !this.message.isCoupon && !this.message.user) {
        MessageBox({
          title: '提示',
          message: '现在退出弹窗，视为放弃此奖品，可以通过传播活动增加抽奖次数。',
          showCancelButton: true
        }).then(async (action) => {
          if (action === 'confirm') {
            this.discard()
            // this.value = false;
            // this.callback("cancel")
          }
        })
      } else {
        this.value = false;
        this.callback("cancel")
      }
    },
    async discard() {
      await this.$httpdf.get(this.apiHost + 'lucky/prize/discard', { prizeId: this.message.prizeInfo.id })
      this.value = false;
      this.callback("cancel")
    }
  },
  created() {
  },
  mounted() {
    if (this.$userInfo) {
      this.name = this.$userInfo.nickName;
    }
    if (this.$mobile) {
      this.mobile = this.$mobile
    }
  }
};
</script>
<style lang="scss" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.msgbox {
  background: url( $imgHost + 'draw_form1.png?t=4') center 0 / 100% no-repeat;
  position: relative;
  width: 328px;
  height: 358px;
  box-sizing: border-box;
  padding: 40px 40px 0;
  &.big {
    background: url( $imgHost + 'draw_form2.png?t=4') center 0 / 100% no-repeat;
    width: 309px;
    height: 521px;
    padding-top: 85px;
    .title {
      display: none;
    }
    .content .tip1 img {
      margin-bottom: 5px;
    }
    .content .tip2 {
      line-height: 18px;
    }
    .btns {
      .my_btn {
        margin-top: 20px;
      }
    }
  }
  &.thanks {
    background: url( $imgHost + 'draw_form3.png?t=3') center 0 / 100% no-repeat;
    height: 329px;
    padding-top: 80px;
    .title {
      background: url( $imgHost + 'draw_form_title2.png?t=3') center 0 / 100% no-repeat;
      top: 10px;
    }
    .content .tip2 {
      margin-top: 30px;
    }
    .btns {
      .my_btn {
        margin-top: 20px;
      }
    }
  }
  .title {
    width: 268px;
    height: 75px;
    background: url( $imgHost + 'draw_form_title1.png?t=3') center 0 / 100% no-repeat;
    position: absolute;
    top: -36px;
    left: 50%;
    transform: translateX(-50%);
  }
  .content {
    text-align: center;
    &.thanks {
      padding-top: 30px;
      .tip1 {
        img {
          margin-bottom: 10px;
        }
      }
    }
    &.replace {
      padding-top: 20px;
      .tip1 {
        margin-bottom: 20px;
      }
    }
    .tip1 {
      font-size: 15px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #F2BA4C;
      img {
        width: 89px;
        margin-bottom: 10px;
      }
    }
    .tip2 {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #4CCBDD;
      line-height: 26px;
      &+.input_txt {
        margin-top: 15px;
      }
    }
    .input_txt {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      &+.input_txt {
        margin-top: 15px;
      }
      .left {
        flex: 1;
        input {
          width : 100%;
        }
      }
      .right {
        width: 75px;
        height: 36px;
        background: #D82C4D;
        border-radius: 5px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        margin-left: 15px;
        @extend .flex-center-center;
      }
      input {
        background: #E4E4E4;
        border-radius: 5px;
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-indent: 10px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666;
        &::-webkit-input-placeholder{
          color: #666;
        }
      }
      ::v-deep .multiselect__tags {
        height: 36px !important;
        line-height: 36px !important;
        min-height: 36px !important;
        border: 0;
        padding-top: 0;
        padding-left: 10px;
        background: #E5E5E5;
        border-radius: 5px;
        font-size: 8px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666;
        .multiselect__input, .multiselect__single{
          background-color: transparent;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0;
          margin: 0;
          line-height: 36px !important;
          font-size: 8px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666;
        }
        .multiselect__placeholder {
          line-height: 36px !important;
          font-size: 8px;
          font-family: PingFang SC;
          font-weight: 500;
          padding: 0;
          color: #666;
        }
      }
      ::v-deep .multiselect__select {
        height: 36px;
        &::before {
          color: #666;
          border-color: #666 transparent transparent;
        }
      }
    }
    
  }
  .btns {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    &.thanks {
      margin-top: 15px;
    }
    .my_btn {
      width: 137px;
      height: 44px;
      background: url( $imgHost + 'draw_form_btn.png?v=1') 0 0 / 100% no-repeat;
      font-size: 16px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #FFFFFF;
      text-align: center;
      line-height: 40px;
      margin-top: 15px;
      &+.my_btn {
        margin-left: 10px;
      }
    }
  }
  .close {
    position: absolute;
    top: -50px;
    right: -2px;
    width: 31px;
    height: 31px;
    z-index: 2000;
  }
}

.replaceList {
  width: 221px;
  margin: 0 auto;
  height: 165px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  .replaceGoods {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid white;
    &:last-child {
      border-bottom: none;
    }
    >span:nth-child(1) {
      padding: 0rem 0;
      width: 150px;
      // text-align: center;
      display: block;
      font-size: 14px;
      // font-weight: bold;
      color: white;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 20px;
    }
    >span:nth-child(2) {
      width: 50px;
      height: 22px;
      background: linear-gradient(180deg, #FFDF5A, #FF7516);
      border-radius: 15px;
      display: block;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 22px;
      text-align: center;
    }
  }
  .goReplace {
    display: block;
    width: 100px;
    height: 37px;
    background: linear-gradient(180deg, #FFC779, #C48D52);
    border-radius: 19px;
    text-align: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #0069C6;
    line-height: 37px;
  }
}
.input_txt {
  ::v-deep .multiselect__tags {
    height: 36px !important;
    line-height: 36px !important;
    min-height: 36px !important;
    border: 0;
    padding-top: 0;
    padding-left: 15px;
    background: #FFFFFF;
    border-radius: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #DF7726;
    .multiselect__input, .multiselect__single{
      background-color: transparent;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0;
      margin: 0;
      line-height: 36px !important;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #DF7726;
    }
    .multiselect__placeholder {
      line-height: 36px !important;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      padding: 0;
      color: #DF7726;
    }
  }
  ::v-deep .multiselect__select {
    height: 36px;
    &::before {
      color: #DF7726;
    }
  }
}
</style>